import { render, staticRenderFns } from "./UnioneSelector.vue?vue&type=template&id=0622bcce&scoped=true&"
import script from "./UnioneSelector.vue?vue&type=script&lang=ts&"
export * from "./UnioneSelector.vue?vue&type=script&lang=ts&"
import style0 from "./UnioneSelector.vue?vue&type=style&index=0&id=0622bcce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0622bcce",
  null
  
)

export default component.exports